export default __webpack_public_path__ + "static/media/svg-9.bb75a913.svg";